<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      title="发货信息"
      id-key="OrderId"
      @create-opened="onCreateOpened"
      :in-dialog="inDialog"
      :data="data"
      :form-rules="rules"
      :save-func="() => {}"
      form-label-width="110px"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="配送公司" prop="ExpressCompanyid">
              <expcompany-select
                ref="expcompanySelect"
                v-model="data.ExpressCompanyid"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="配送单号" prop="ExpressNo">
              <el-input
                size="mini"
                v-model="data.ExpressNo"
                placeholder="请输入配送单号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="实际配送金额" prop="ExpressAmount">
              <el-input
                size="mini"
                v-model="data.ExpressAmount"
                placeholder="请输入实际配送金额"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>商品信息</el-divider>
        <el-table border :data="data.SendOrder" style="width: 100%">
          <el-table-column
            prop="OrderNo"
            label="订单编号"
            align="center"
            min-width="100"
          />
          <el-table-column
            prop="OrderDate"
            label="订单日期"
            align="center"
            min-width="100"
          />
          <el-table-column prop="GoodsCode" label="商品编号" align="center" />
          <el-table-column prop="GoodsName" label="商品名称" align="center" />
          <el-table-column
            prop="AttributeName"
            label="规格型号"
            align="center"
          />
          <el-table-column prop="AttributeCode" label="货号" align="center" />
          <el-table-column prop="MainunitCount" label="发货数量" width="90px">
            <template slot-scope="{ row }">
              <el-input
                v-if="!data.OperId"
                v-model="row.MainunitCount"
                type="number"
                @input="count(row)"
                @blur="onBlur(row, 'MainunitCount')"
                @focus="onFocus(row, 'MainunitCount')"
                disabled
              ></el-input>
              <span v-else>{{ row.MainunitCount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            width="80px"
            v-if="notOrders"
          >
            <template slot="header">
              <i
                class="el-icon-circle-plus-outline add-icon"
                @click="addGoods"
              ></i>
            </template>
            <template slot-scope="{ $index }">
              <el-button
                icon="el-icon-delete"
                type="text"
                @click="delGoods($index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button size="mini" type="primary" :loading="saving" @click="send"
          >确认发货</el-button
        >
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>

    <goods-dialog
      ref="goodsDialog"
      in-dialog
      selectable
      :sameBusiness="true"
      :multiple="false"
      @select="setGoods"
    />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import expcompanySelect from "@/components/sale/expcompany/select";
import goodsDialog from "@/components/sale/order/listDialogmul";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    expcompanySelect,
    goodsDialog,
  },
  data() {
    return {
      data: {
        ExpressCompanyid: null, //配送公司编号
        ExpressName: "", //配送公司名称
        ExpressNo: "", //配送单号
        ExpressAmount: null, //实际配送金额
        SendOrder: [],
      },
      saving: false,
      api: require("@/api/sale/order/order").default,
      isMB: this.$store.state.isMB,
      rules: {
        ExpressCompanyid: [{ required: true, message: "请选择配送公司" }],
        ExpressNo: [{ required: true, message: "请填写配送单号" }],
        ExpressAmount: [
          { required: true, message: "请填写实际配送金额" },
          { validator: this.$commonJs.validateRules.num },
        ],
      },
      notOrders: true,
    };
  },
  computed: {},
  methods: {
    setGoods(data) {
      console.log("data", data);
      this.data.SendOrder = data.OrderGoods;
      this.data.SendOrder.forEach((item) => {
        item.OrderGoodsId = item.RecordId;
        item.Quantity = item.MainunitCount;
      });
      this.data.StoreId = data.StoreId;
      this.data.ContactName = data.ReceivingPerson;
      this.data.ContactPhone = data.ReceivingPhone;
      this.data.ContactAddress = data.ReceivingAddress;
    },
    addGoods() {
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({ OrderState: 1, PromotionType: 0, OrderMode: 0 });
      });
    },
    delGoods(index) {
      if (this.data.SendOrder.length > 0) this.data.SendOrder.splice(index, 1);
    },
    onCreateOpened(data) {
      // this.data.SendOrder = [];
      // var order = {
      //   OrderId: data.OrderId,
      //   SendStatus: 2,
      //   SendGoods: data.Goods.map((x) => {
      //     return {
      //       OrderGoodsId: x.OrderGoodsId,
      //       Quantity: x.Quantity,
      //     };
      //   }),
      // };
      // this.data.SendOrder.push(order);
    },
    send() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        var logistics = this.$refs.expcompanySelect.data.find(
          (x) => x.RecordId == this.data.ExpressCompanyid
        );
        console.log(logistics, "aa");
        this.saving = true;
        this.data.ExpressCompanyName = logistics.CompanyName;
        console.log(this.data, "bb");
        this.api.sendV2(this.data).then((res) => {
          this.saving = false;
          if (res.Code == 0) {
            this.$emit("close-saved", { ...this.data });
            this.close(true);
            this.$message.success(res.Msg);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
  },
};
</script>